export default __webpack_public_path__ + "static/media/platform_device_health_monitoring.22a37bcd.svg";